module.exports = __webpack_public_path__ + "static/media/landing-bg.00fadd1a.jpg";